import { ImportTableDescriptorType } from '../../../../../../types';

type GetDescriptorCellStylingReturnType = {
    styles: Record<string, string>;
    classes: string;
};

export function getDescriptorCellStyling(
    descriptor: ImportTableDescriptorType,
    editing: boolean
): GetDescriptorCellStylingReturnType {
    const styles: Record<string, string> = {};
    if (descriptor.nestingLevel) {
        styles['--nested-padding'] = `${descriptor.nestingLevel * 20}px`;
    }

    let classes = '';
    if (styles['--nested-padding']) {
        classes = `${classes} nested-padding`;
    }
    if (editing) {
        classes = `${classes} cell--editing`;
    }

    return {
        styles,
        classes,
    };
}
